// ABOUTME: Configures Honeybadger error reporting for the client portal
// ABOUTME: Re-exports warnAndNotify and reports render errors that React error boundaries catch
import {
  configureHoneybadger as _configureHoneybadger,
  Honeybadger,
} from '@execonline-inc/error-reporting.private';
import { warn } from '@execonline-inc/logging';
import type { ErrorInfo } from 'react';
import { readVarM } from '../Assertions/environments';

export { warnAndNotify } from '@execonline-inc/error-reporting.private';

export const configureHoneybadger = () =>
  _configureHoneybadger({
    apiKey: readVarM('VITE_HB_KEY'),
    environment: readVarM('VITE_APP_ENV'),
    revision: readVarM('VITE_APP_VERSION'),
  });

// Errors that reach an error boundary never hit window.onerror, so without this they would only
// ever be logged by the boundary itself. Passed to createRoot as onCaughtError.
export const notifyCaughtRenderError = (error: unknown, info: ErrorInfo): void => {
  warn('React error boundary caught:', error, info.componentStack);
  Honeybadger.notify(error instanceof Error ? error : String(error), {
    context: { componentStack: info.componentStack },
  });
};
